export default {
  default: property => {
    return `transition: ${property || "all"} 0.15s linear`
  },
}
